import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataStatus } from 'src/app/models/Helpers/data-status';
import { Loader } from 'src/app/models/Helpers/loader';
import { AuthService } from '../../core/services/user-services/auth.service';

@Component({
  selector: 'app-confirmedemail-callback',
  templateUrl: './confirmedemail-callback.component.html',
  styleUrls: ['./confirmedemail-callback.component.scss']
})
export class ConfirmedemailCallbackComponent implements OnInit {

  confirmationEmailLoader = new Loader();
  confirmationEmailStatus = new DataStatus();

  linkNotValid: boolean;
  userNotFound: boolean;
  linkIsExpired: boolean;
  generalError: boolean;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const email = this.route.snapshot.queryParamMap.get('email');
    const clientId = this.route.snapshot.queryParamMap.get('clientId');

    if (!token || !email || !clientId) {
      this.linkNotValid = true;
      return;
    }

    this.confirmEmail(token, email, clientId);
  }

  confirmEmail(token: string, email: string, clientId: string) {
    this.confirmationEmailLoader.show();

    this.authService.confirmEmail(token, email, clientId)
      .subscribe(
        () => {
          this.confirmationEmailStatus.setStatus('success');
          this.confirmationEmailLoader.hide();
        },
        error => {
          console.log('Confirmation Email error', error);
          this.confirmationEmailStatus.setStatus('failure');
          switch (error.error) {
            case 'Utente non registrato': this.userNotFound = true; break;
            case 'Link non valido': this.linkNotValid = true; break;
            case 'Link scaduto': this.linkIsExpired = true; break;
            case 'Errore': this.generalError = true; break;
          }
          this.confirmationEmailLoader.hide();
        }
      );
  }

}
